// src/helpers/systemConfigCache.ts
// Cache-first loader cho SystemConfig (SystemService/GetSystemConfig) — dùng chung giữa
// Login, System > Configuration và Issuance Plans để tránh gọi lại API khi cache còn hạn.
// Đọc chi tiết thiết kế trong README.md (mục 3.1).

import { CacheService } from 'services/cache';
import { CacheConfig } from 'services/cache/CacheConfig';
import { setConfig } from 'slices/systemConfiguration/reducer';
import { fetchSystemConfig } from 'slices/systemConfiguration/thunk';
import { SystemConfiguration } from 'pages/SystemConfiguration/types';

/**
 * Nạp SystemConfig vào Redux store: ưu tiên đọc từ localStorage (lms_cache_system_config),
 * nếu cache miss/hết hạn mới gọi API và lưu lại cache.
 */
export const loadSystemConfigWithCache = async (dispatch: any): Promise<void> => {
  const cacheKey = CacheConfig.SYSTEM_CONFIG.key;
  const cacheTtl = CacheConfig.SYSTEM_CONFIG.ttl;

  const cached = CacheService.get<SystemConfiguration>(cacheKey);

  if (cached.cached && cached.data) {
    dispatch(setConfig(cached.data));
    return;
  }

  const result = await dispatch(fetchSystemConfig());
  if (result.payload) {
    CacheService.set(cacheKey, result.payload, cacheTtl);
  }
};
